import ContentLoader from 'react-content-loader';
import styled, { useTheme } from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../../../common/responsive.js';
import WidthContainer from '../../../../../components/WidthContainer/index';

const DemoContainer = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 24px;
  gap: 16px;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 8px;
  }
`;

const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  @media ${PHONE_MEDIA_QUERY} {
    align-items: center;
    gap: 16px;
  }
`;

const Line = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.border.primary};
  @media ${PHONE_MEDIA_QUERY} {
    margin-top: 30px;
    margin-bottom: 30px;
  }
`;

const ContentRow = styled.div`
  display: flex;
  width: 100%;
  gap: 64px;
  justify-content: flex-start;

  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    gap: 24px;
    align-items: flex-start;
  }
`;

const InformationContainer = styled.div`
  width: 400px;
  display: flex;
  gap: 24px;
  flex-direction: column;

  @media ${PHONE_MEDIA_QUERY} {
    width: 100%;
    max-width: 407px;
    gap: 16px;
  }
`;

const CardSkeleton = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width={417}
      height={231}
      viewBox='0 0 417 231'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
      style={{ width: '100%', maxWidth: '417px' }}
    >
      <rect x='0' y='0' rx='16' ry='16' width='417' height='231' />
    </ContentLoader>
  );
};

const LongLine = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width={250}
      height={33}
      viewBox='0 0 250 33'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
      style={{ width: '100%', maxWidth: '250px' }}
    >
      <rect x='0' y='0' rx='4' ry='4' width='250' height='33' />
    </ContentLoader>
  );
};

const SmallLine = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width={80}
      height={33}
      viewBox='0 0 80 33'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
      style={{ width: '100%', maxWidth: '80px' }}
    >
      <rect x='0' y='0' rx='4' ry='4' width='80' height='33' />
    </ContentLoader>
  );
};

const MessageSkeleton = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width={407}
      height={60}
      viewBox='0 0 407 60'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
      style={{ width: '100%', maxWidth: '407px' }}
    >
      <rect x='0' y='0' rx='4' ry='4' width='407' height='60' />
    </ContentLoader>
  );
};

const ButtonSkeleton = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width={100}
      height={48}
      viewBox='0 0 100 48'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
    >
      <rect x='0' y='0' rx='8' ry='8' width='100' height='48' />
    </ContentLoader>
  );
};

const ShortButtonSkeleton = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      speed={2}
      width={60}
      height={48}
      viewBox='0 0 60 48'
      backgroundColor={`${theme.background.secondary}`}
      foregroundColor={`${theme.special.skeleton}`}
    >
      <rect x='0' y='0' rx='8' ry='8' width='60' height='48' />
    </ContentLoader>
  );
};

const FormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

const ConfirmationSkeleton = () => {
  const theme = useTheme();
  return (
    <WidthContainer>
      <DemoContainer>
        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-start',
          }}
        >
          <ContentLoader
            speed={2}
            width={200}
            height={40}
            viewBox='0 0 80 40'
            backgroundColor={`${theme.background.secondary}`}
            foregroundColor={`${theme.special.skeleton}`}
            style={{ width: '100%', maxWidth: '80px' }}
          >
            <rect x='0' y='0' rx='4' ry='4' width='80' height='40' />
          </ContentLoader>
        </div>
        <ContentRow>
          <div style={{ width: '100%', maxWidth: '417px' }}>
            <CardSkeleton />
          </div>
          <FormContainer>
            <FormRow>
              <LongLine />
              <SmallLine />
            </FormRow>
            <FormRow>
              <SmallLine />
            </FormRow>
          </FormContainer>
        </ContentRow>
        <Line />
        <ContentRow>
          <FormContainer>
            <FormRow>
              <LongLine />
              <SmallLine />
            </FormRow>
            <FormRow style={{ justifyContent: 'flex-end', gap: 20 }}>
              <ShortButtonSkeleton />
              <ButtonSkeleton />
            </FormRow>
          </FormContainer>
        </ContentRow>
      </DemoContainer>
    </WidthContainer>
  );
};

export default ConfirmationSkeleton;
